<template>
    <b-modal
        ref="modalUndo"
        lazy
        title-tag="h2"
        title="Undo Check In"
        footer-class="d-flex"
    >
        Undoing check in will permanently delete any records associated with
        this reservation.
        <template v-slot:modal-footer="{ close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Undo Check In
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import BoardingService from "@/services/boarding.js";

export default {
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            boardingId: null
        };
    },
    methods: {
        open(boardingId) {
            this.$refs.modalUndo.show();
            this.boardingId = boardingId;
        },
        async proceed() {
            try {
                this.isLoading = true;
                let undo = await BoardingService.undoCheckIn(this.boardingId);
                this.isLoading = false;

                if (undo) {
                    this._message(
                        "Check-in for reservation successfully undone"
                    );
                    this.$refs.modalUndo.hide();
                    this.$emit("success", this.boardingId);
                } else {
                    throw new Error("Error: Unable to undo check-in");
                }
            } catch (error) {
                this.isLoading = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
